import {
	startOfDay,
	endOfDay,
	startOfWeek,
	endOfWeek,
	startOfMonth,
	endOfMonth,
	startOfYear,
	endOfYear,
	subDays,
	subYears,
	format,
	setHours,
	setMilliseconds,
	setMinutes,
	setSeconds,
} from 'date-fns';
import { Operators } from '../../../enum/operators.enum';
import { Predicate } from '../../../models/predicate.model';
import { FiltrosDespesas } from '../types/filters';

const buildDateFilter = (vencimento: string) => {
	const hoje = new Date();
	let inicioData: Date | null = null;
	let finalData: Date | null = null;

	switch (vencimento) {
		case 'hoje':
			inicioData = startOfDay(hoje);
			finalData = endOfDay(hoje);
			break;
		case 'semana':
			inicioData = startOfWeek(hoje, { weekStartsOn: 0 });
			finalData = endOfWeek(hoje, { weekStartsOn: 0 });
			break;
		case 'mes':
			inicioData = startOfMonth(hoje);
			finalData = endOfMonth(hoje);
			break;
		case 'ano':
			inicioData = startOfYear(hoje);
			finalData = endOfYear(hoje);
			break;
		case 'ultimos_30':
			inicioData = startOfDay(subDays(hoje, 30));
			finalData = endOfDay(hoje);
			break;
		case 'ultimos_12':
			inicioData = startOfDay(subYears(hoje, 1));
			finalData = endOfDay(hoje);
			break;
		case 'todos':
			inicioData = null;
			finalData = null;
			break;
		case 'personalizado':
			break;
	}

	return { inicioData, finalData };
};
const buildFiltersPredicate = (filters: FiltrosDespesas, idUnidade: number, inicioPersonalizado?: Date, fimPersonalizado?: Date) => {
	const predicate = new Predicate();
	predicate.addOption('ativo', true);
	predicate.addOption('unidade.id', idUnidade);

	Object.keys(filters).forEach((key) => {
		if (filters[key] !== null) {
			if (key === 'dsDespesa') {
				predicate.addOption(key, filters[key], Operators.CONTAINS);
			} else if (key === 'vencimento') {
				if (filters[key] === 'personalizado') {
					if (inicioPersonalizado) {
						const inicioDia = setMilliseconds(setSeconds(setMinutes(setHours(inicioPersonalizado, 0), 0), 0), 0);
						predicate.addMultiOption('dhVencimento', format(inicioDia, "yyyy-MM-dd'T'HH:mm:ss"), Operators.GREATER_THAN_OR_EQUAL, true);
					}
					if (fimPersonalizado) {
						const fimDia = setMilliseconds(setSeconds(setMinutes(setHours(fimPersonalizado, 23), 59), 59), 999);
						predicate.addMultiOption('dhVencimento', format(fimDia, "yyyy-MM-dd'T'HH:mm:ss"), Operators.LESS_THAN_OR_EQUAL, true);
					}
				} else {
					const { inicioData, finalData } = buildDateFilter(filters[key]);

					if (inicioData) {
						predicate.addMultiOption('dhVencimento', format(inicioData, "yyyy-MM-dd'T'HH:mm:ss"), Operators.GREATER_THAN_OR_EQUAL, true);
					}
					if (finalData) {
						predicate.addMultiOption('dhVencimento', format(finalData, "yyyy-MM-dd'T'HH:mm:ss"), Operators.LESS_THAN_OR_EQUAL, true);
					}
				}
			} else {
				predicate.addOption(key, filters[key]);
			}
		}
	});

	return predicate;
};

export default buildFiltersPredicate;
